<template>
  <div>
    <el-form
      ref="postForm"
      :label-width="labelWidth"
      :rules="currentRules"
      :label-position="position"
      :inline="inline"
      :model="currentPostForm"
      class="demo-form-inline"
    >
      <el-form-item v-for="(item) in forms" :key="item.bindValue" :required="item.require" :prop="item.bindValue" :label="item.label || ''">
        <el-input v-if="item.type == 'input'" v-model="currentPostForm[item.bindValue]" :type="item.inputType || 'text'" :placeholder="item.placeholder || ('请输入' + (item.label || ''))" />
        <wq-select v-if="item.type == 'select'" :disabled="item.disabled" :multiple="item.multiple" :name="item.bindValue" :selected.sync="currentPostForm[item.bindValue]" :value-name="item.value || 'id'" :text-name="item.text || 'name'" :data-func="item.dataFunc" :placeholder="item.placeholder || ('请选择' + (item.label || '')) " @change="changeSelect" />
        <el-input v-if="item.type == 'textarea'" v-model="currentPostForm[item.bindValue]" type="textarea" :rows="item.rows || 3" :placeholder="item.placeholder || '请输入'" />
        <el-input-number v-if="item.type == 'inputnumber'" v-model="currentPostForm[item.bindValue]" :min="item.min" :label="item.label" />
        <el-checkbox v-if="item.type == 'checkbox'" v-model="currentPostForm[item.bindValue]" :true-label="item.activeValue || true" :false-label="item.inactiveValue || false" />
        <qiniu-upload v-if="item.type == 'uploadimage'" :ref="'uploadqiniu' + item.bindValue" :files="currentPostForm[item.bindValue]" :up-type="item.upType" :name="item.bindValue" :limit="item.limit || 1" :auto-upload="true" @success="uploadSuccess" />
        <el-date-picker v-if="item.type == 'daterange'" v-model="currentPostForm[item.bindValue]" value-format="yyyy-MM-dd" :picker-options="item.options" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="fnSetTime(item)" />

        <el-date-picker v-if="item.type == 'datepicker'" v-model="currentPostForm[item.bindValue]" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" />
        <el-time-select
          v-if="item.type == 'timepicker'"
          v-model="currentPostForm[item.bindValue]"
          :picker-options="item.options || { start: '08:30', step: '00:10', end: '18:30' }"
          placeholder="选择时间"
        />
        <slot v-if="item.type == 'custom'" :name="item.bindValue" :currentForm="currentPostForm" :item="item" />
        <span v-if="item.tips" style="color:#F56C6C" class="element_margin_left" v-html="item.tips" />
      </el-form-item>
    </el-form>
    <div style="padding-right: 0px!important;" class="el-dialog__footer">
      <el-button v-if="showSubmit" type="primary" class="search-btn" @click="submitPostForm()">提交</el-button>
    </div>
  </div>
</template>

<script>

import QiniuUpload from './QiniuUpload'
import WqSelect from './WqSelect'
export default {
  name: 'SelectBox',
  components: {
    WqSelect,
    QiniuUpload

  },
  props: {
    // [{type:'input',bindValue:'child_id'},{type:'select',bindValue:'shop_id'}]
    forms: {
      type: Array,
      default() {
        return []
      }
    },
    position: {
      type: String,
      default: ''
    },
    showSubmit: {
      type: Boolean,
      default: true
    },
    inline: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: String,
      default: '50px'
    },
    postForm: {
      type: Object,
      require: true,
      default() {
        return { }
      }
    },
    rules: {
      type: Object,
      default() {
        return { }
      }
    }
  },
  data() {
    return {
      shopLists: [],
      currentPostForm: {},
      currentRules: {}
    }
  },
  watch: {
    postForm: {
      handler(newVal, oldVal) {
        this.$set(this, 'currentPostForm', Object.assign({}, newVal))
      },
      deep: true // 深度观察 obj 的变化
    }
  },
  created() {
    this.$set(this, 'currentPostForm', Object.assign({}, this.postForm))
    this.createRule()
  },
  methods: {
    createRule() {
      this.currentRules = {}
      this.forms.forEach(item => {
        if (this.rules[item.bindValue]) {
          this.currentRules[item.bindValue] = this.rules[item.bindValue]
        } else if (item.require) {
          if (item.type === 'inputnumber') {
            this.currentRules[item.bindValue] = [{
              require: true,
              validator: (rule, value, callback) => {
                if (value === 0) {
                  callback(new Error(`请填写${item.label}`))
                }
                callback()
              },
              trigger: ['blur', 'change']
            }]
          } else {
            this.currentRules[item.bindValue] = [{ required: true, message: this.fnGetRuleTips() + (item.label || ''), trigger: ['blur', 'change'] }]
          }
        }
      })
    },
    fnGetRuleTips(type) {
      switch (type) {
        case 'checkbox':
        case 'select':
          return '请选择'
        case 'uploadimage':
          return '请上传'
        default:
          return '请输入'
      }
    },
    resetFields() {
      this.$refs['postForm'].resetFields()
    },
    submitPostForm() {
      this.$refs['postForm'].validate((valid) => {
        if (valid) {
          this.$emit('submit', this.currentPostForm)
        } else {
          return false
        }
      })
    },
    changeSelect(e) {
      this.$refs['postForm'].validateField(e.name)
    },
    valideAll() {
      return new Promise((resolve, reject) => {
        this.$refs['postForm'].validate().then(rect => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    uploadSuccess(e) {
      const { urls, name } = e
      this.currentPostForm[name] = urls.join(',')
      this.$refs['postForm'].validateField(e.name)
    },
    setPostForm(e, value) {
      if (this.currentPostForm[e]) {
        this.currentPostForm[e] = value
      }
    },
    fnSetTime(e) {
      if (this.currentPostForm[e.bindValue]) {
        this.currentPostForm[e.mapValue[0]] = this.currentPostForm[e.bindValue][0]
        this.currentPostForm[e.mapValue[1]] = this.currentPostForm[e.bindValue][1]
      } else {
        this.currentPostForm[e.mapValue[0]] = ''
        this.currentPostForm[e.mapValue[1]] = ''
      }
    },
    getPostFormInfo() {
      return this.currentPostForm
    }
  }
}
</script>

<style scoped>
    .search-btn {
       margin-bottom: 18px;
    }
</style>
